import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withStyles, Hidden } from '@material-ui/core'
import { read, list } from 'actions/data'
import { getContactsWithEmails } from 'actions/contacts'
import Desktop from './Desktop'
import Mobile from './Mobile'
import FullEmailDialog from './FullEmailDialog'
import { listSettings, listPreferences } from 'actions/AccountSettings'
import { currentSession as currentCredentials } from 'actions/auth'
import { listInbox, setCursor } from 'actions/inbox'
// import { DATA_API_URL } from 'utils/AllURLs'

const styles = theme => ({
  main: {
    width: '100%',
    height: '100%',
    display: 'flex',
    [theme.breakpoints.down('sm')]: {
      display: 'block',
    },
  },
})

export default connect(
  state => ({
    conversationSelected: state.inbox.conversationSelected,
    accountSettingsLoaded: state.AccountSettings.loaded,
    last_interaction: state.data?.['inbox/last']?.last_interaction,
    // conversationsListUserFilter: state.inbox.conversationsListUserFilter.filter,
  }),
  dispatch =>
    bindActionCreators(
      {
        list,
        read,
        getContactsWithEmails,
        listSettings,
        currentCredentials,
        listPreferences,
        listInbox,
        setCursor,
      },
      dispatch,
    ),
)(
  withStyles(styles)(
    class Inbox extends Component {
      componentDidMount() {
        const {
          getContactsWithEmails,
          accountSettingsLoaded,
          listSettings,
          currentCredentials,
          listPreferences,
          list,
        } = this.props

        currentCredentials()

        if (!accountSettingsLoaded) {
          listPreferences()
          listSettings()
        }

        list('phonenumbers')

        getContactsWithEmails()

        this.interval = setInterval(() => this.read(), 60000)
      }

      componentDidUpdate(prevProps) {
        if (
          prevProps.last_interaction &&
          prevProps.last_interaction !== this.props.last_interaction
        ) {
          this.props.setCursor('', 'all').then(() => {
            this.props.listInbox({ infiniteLoader: false, endpoint: 'all' })
          })
        }
      }

      componentWillUnmount() {
        clearInterval(this.interval)
      }

      read = () => {
        const { read, conversationSelected } = this.props

        if (conversationSelected) {
          read(
            conversationSelected,
            'inbox',
            'inbox/conversation',
            'contact_id',
          )
        }
      }

      render() {
        const { classes, location } = this.props
        return (
          <div className={classes.main}>
            <Hidden smDown>
              <Desktop location={location} />
            </Hidden>
            <Hidden mdUp>
              <Mobile location={location} />
            </Hidden>
            <FullEmailDialog />
          </div>
        )
      }
    },
  ),
)
